<template>
  <div>
    <div class="erpTitle titleImg">
      <img class="image"
           src="./erp/erptitleNew.jpg"
           alt="">
    </div>

    <div class='erpTitle'>
      <div class="erpBox">
        <img class="image"
             src="./erp/erpNew.png"
             alt="">
      </div>
    </div>
    <!-- <div class="erpTitle erpTxet" >
        <p>随着国家政策变更、供给侧改革及互联网的深入发展，流通行业的市场环境发生了很大的变化，企业对内部管理的要求越来越高。在这样的背景下，很多企业对ERP管理系统也提出了更高的要求。</p>
        <p>如何通过ERP系统提升企业自身管理精细度，提升市场营销能力、提升客户服务体验，成为了企业新的课题。</p>
        <div>新市场环境下对 <span>ERP系统</span> 的要求</div>
    </div>
    <div class="erpTitle erpone" >
        <img src="./erp/erpone.png" alt="">
    </div>
    <div class="erpTitle erptwo " >
        <img src="./erp/erptwo.png" alt="">
    </div> -->
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun: 100/192;
.erpTitle {
  display: flex;
  // justify-content: center;
  background-color: #ffffff;
  width: 100%;
}
.titleImg {
  height: 460px * $sun;
}
.image {
  width: 100%;
  height: 100%;
}
.erpicon {
  padding: 50px * $sun 0 40px * $sun 0;
}
.erpTxet {
  flex-direction: column;
  padding: 0 360px * $sun;
  font-size: 24px * $sun;
  color: #666666;
  line-height: 200%;
}
.erpTxet p {
  padding-bottom: 40px * $sun;
}
.erpTitle div {
  font-size: 28px * $sun;
  color: #000000;
  padding-bottom: 44px * $sun;
}
.erpTitle div span {
  color: #ff0000;
}
.erpone {
  padding-bottom: 50px * $sun;
}
.erptwo {
  padding-bottom: 64px * $sun;
}
.erpBox {
  width: 1260px * $sun;
  margin: 0 auto;
}
</style>
